import { Injectable } from '@angular/core';
import { Association } from '@interfaces/association/1.0';
import { Observable } from 'rxjs';

@Injectable()
export abstract class AbstractAssociationService {
  abstract create(association: Partial<Association>): Observable<Association>;
}
